import React from 'react';
import { Grid, Typography, List, ListItem, Paper } from '@mui/material';
import { makeStyles } from 'utils/makeStylesAdapter';
import { ButtonConsensus } from 'components';
import { toast } from 'react-toastify';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: 400,
    marginTop: theme.spacing(1),
  },
  containerList: {
    padding: 0,
  },
  listitem: {
    width: '100%',
    padding: theme.spacing(2),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
  },
  itemLeft: {
    marginRight: theme.spacing(1),
  },
  importButton: {
    margin: theme.spacing(1, 0, 0, 0),
  },
  containerSwitch: {
    marginTop: theme.spacing(5),
  },
}));

const ListInquiryItem = props => {
  const { inquiryList, handleSelectInquiry, loadingImport } = props;

  const classes = useStyles();

  const handleImportClick = (internalSystemNumber, policeInquiryNumber) => {
    if (policeInquiryNumber?.length === 0) {
      toast.error('o inquérito importado precisa ter número de IP.');
      return;
    }
    handleSelectInquiry(internalSystemNumber);
  };

  return (
    <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
      <List component="div" aria-label="main mailbox">
        <ListItem className={classes.containerList} /*onClick={handleSelectInquiry}*/>
          <Grid container spacing={2}>
            {inquiryList.map(item => (
              <Grid
                key={item.internalSystemNumber}
                size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                <Paper elevation={3} className={classes.listitem}>
                  <div className={classes.row}>
                    <div className={classes.item}>
                      <Typography className={classes.itemLeft}>Numero interno:</Typography>
                      <Typography>{item.internalSystemNumber}</Typography>
                    </div>
                    <div className={classes.item}>
                      <Typography className={classes.itemLeft}>Classe:</Typography>
                      <Typography>{item.classification}</Typography>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.item}>
                      <Typography className={classes.itemLeft}>Arquimedes - auto:</Typography>
                      <Typography>{item.arquimedesAuto}</Typography>
                    </div>
                    <div className={classes.item}>
                      <Typography className={classes.itemLeft}>IP:</Typography>
                      <Typography>{item.policeInquiryNumber}</Typography>
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.item}>
                      <ButtonConsensus
                        title="Importar"
                        onClick={() => handleImportClick(item.internalSystemNumber,item.policeInquiryNumber)}
                        margin={0}
                        className={classes.importButton}
                        size="medium"
                        disabled={loadingImport}
                      />
                    </div>
                  </div>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </ListItem>
      </List>
    </Grid>
  );
};

export default ListInquiryItem;
